import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useRef } from '@redneckz/uni-jsx/lib/hooks';
import { mapChildren } from '../../utils/mapChildren.js';
import { style } from '../../utils/style.js';
import { getContainerHeight } from './getContainerHeight.js';
import { SwipeListItem } from './SwipeListItem.js';
const childStyleMap = ['min-w-full', 'lg:min-w-[50%]', 'lg:min-w-[33.3%]', 'lg:min-w-[25%]'];
export const SwipeListContainer = JSX(({ className, itemClassName, containerRef, activeIndex, visibleItemCount = 0, gap = 0, padding = 0, listType = 'horizontal-list', snapAlign = 'snap-center', minHeight, children, onVisibleItemsChange, onVisibleIndicesChange, }) => {
    const observerOptions = {
        sensitivity: 1,
        rootRef: containerRef,
    };
    const itemsVisibilityListRef = useRef([]);
    const handleIntersection = useCallback((idx, entry) => {
        const itemsVisibilityList = [...(itemsVisibilityListRef.current || [])];
        itemsVisibilityList[idx] = entry;
        itemsVisibilityListRef.current = itemsVisibilityList;
        onVisibleItemsChange && onVisibleItemsChange(itemsVisibilityList);
        onVisibleIndicesChange && onVisibleIndicesChange(getVisibleIndices(itemsVisibilityList));
    }, [onVisibleItemsChange, onVisibleIndicesChange]);
    const additionPadding = visibleItemCount > 0 ? gap * Number(visibleItemCount) - 1 : 0;
    const isVerticalList = listType === 'vertical-list';
    const isHorizontalList = listType === 'horizontal-list';
    const containerStyle = {
        ...(isHorizontalList ? getContainerOffset(padding, additionPadding) : {}),
        ...(isVerticalList ? getContainerHeight(minHeight) : {}),
        gap: `${gap}px`,
    };
    return (_jsx("div", { className: style('box-border overflow-auto no-scrollbar', listType, className), style: containerStyle, ref: containerRef, role: "list", children: mapChildren((child, idx) => (_jsx(SwipeListItem, { className: style(snapAlign, visibleItemCount ? childStyleMap[visibleItemCount - 1] : '', {
                'h-full': isVerticalList,
            }, itemClassName), style: isHorizontalList ? getContainerOffset(padding / 4) : {}, activeIndex: activeIndex, idx: idx, observerOptions: observerOptions, onIntersection: handleIntersection, children: child }, String(idx))))(children) }));
});
// Styles used to compensate outer container padding to get rid of clipping effect
const getContainerOffset = (padding, additionalPadding = 0) => ({
    marginLeft: `${-padding}px`,
    marginRight: `${-padding}px`,
    paddingLeft: `${padding}px`,
    paddingRight: `${padding + additionalPadding}px`,
});
const getVisibleIndices = (itemsVisibilityList) => itemsVisibilityList
    .map((_, i) => [_, i])
    .filter(([_]) => _ && _.intersectionRatio >= 0.9)
    .map(([, i]) => i);
//# sourceMappingURL=SwipeListContainer.js.map